// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-sidenav-container, mat-sidenav-content, mat-sidenav {
  height: 100%;
}

mat-sidenav {
  width: 250px;
}

.breadcrumb-container {
  background-color: #f8f9fa;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
  padding: 8px 0;
}
.breadcrumb-container ::ng-deep .xng-breadcrumb-root {
  padding: 0;
  margin: 0;
}
.breadcrumb-container ::ng-deep .xng-breadcrumb-separator {
  color: var(--brand-accent, #2563eb);
}
.breadcrumb-container ::ng-deep .xng-breadcrumb-link {
  color: #666;
}
.breadcrumb-container ::ng-deep .xng-breadcrumb-link:hover {
  color: var(--brand-accent, #2563eb);
  text-decoration: none;
}
.breadcrumb-container ::ng-deep .xng-breadcrumb-trail {
  color: var(--brand-accent, #2563eb);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,yBAAA;EACA,gDAAA;EACA,cAAA;AAGF;AADE;EACE,UAAA;EACA,SAAA;AAGJ;AAAE;EACE,mCAAA;AAEJ;AACE;EACE,WAAA;AACJ;AACI;EACE,mCAAA;EACA,qBAAA;AACN;AAGE;EACE,mCAAA;EACA,gBAAA;AADJ","sourcesContent":["mat-sidenav-container, mat-sidenav-content, mat-sidenav {\n  height: 100%;\n}\nmat-sidenav {\n  width: 250px;\n}\n.breadcrumb-container {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid rgba(212,175,55,0.2);\n  padding: 8px 0;\n\n  ::ng-deep .xng-breadcrumb-root {\n    padding: 0;\n    margin: 0;\n  }\n\n  ::ng-deep .xng-breadcrumb-separator {\n    color: var(--brand-accent, #2563eb);\n  }\n\n  ::ng-deep .xng-breadcrumb-link {\n    color: #666;\n\n    &:hover {\n      color: var(--brand-accent, #2563eb);\n      text-decoration: none;\n    }\n  }\n\n  ::ng-deep .xng-breadcrumb-trail {\n    color: var(--brand-accent, #2563eb);\n    font-weight: 500;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
